import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { classNames } from '@/lib/format';

type Variant = 'primary' | 'ghost' | 'danger';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: 'sm' | 'md';
  iconOnly?: boolean;
  leftIcon?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = 'primary', size = 'md', iconOnly, leftIcon, className, children, ...rest },
  ref,
) {
  const cls = classNames(
    'btn',
    variant === 'ghost' && 'btn--ghost',
    variant === 'danger' && 'btn--danger',
    size === 'sm' && 'btn--sm',
    iconOnly && 'btn--icon',
    className,
  );
  return (
    <button ref={ref} className={cls} {...rest}>
      {leftIcon}
      {children}
    </button>
  );
});
